(function() {
  'use strict';

  // Offset de tiempo del servidor
  let serverTimeOffset = 0;
  let isSynced = false;
  let lastLocalTime = Date.now();

  // Configuración del timer
  const timerConfig = {
    container: null,
    colorDatesData: null,
    currentInterval: null,
    syncInterval: null,
    clockCheckInterval: null,
    currentColor: null,
    hasPriority: false,
    
    // Elementos del DOM
    elements: {
      days: null,
      hours: null,
      minutes: null,
      seconds: null
    }
  };

  // Detectar si el usuario cambió la hora del sistema
  function detectClockManipulation() {
    const currentLocalTime = Date.now();
    const expectedElapsed = 1000;
    const tolerance = 3000;
    
    const actualElapsed = currentLocalTime - lastLocalTime;
    
    if (Math.abs(actualElapsed - expectedElapsed) > tolerance) {
      window.location.reload();
    }
    
    lastLocalTime = currentLocalTime;
  }

  // Función auxiliar para fallback con Shopify
  async function syncWithShopify() {
    try {
      const response = await fetch('/cart.js');
      const serverDate = response.headers.get('date');
      const serverTime = new Date(serverDate);
      
      // Ajuste para compensar desfase
      const ajusteHoras = 42 * 60 * 60 * 1000;
      const ajusteMinutos = 35 * 60 * 1000;
      const ajusteSegundos = 40 * 1000;
      const ajusteMs = ajusteHoras + ajusteMinutos + ajusteSegundos;
      
      const serverTimeAjustado = new Date(serverTime.getTime() + ajusteMs);
      const localTime = new Date();
      serverTimeOffset = serverTimeAjustado - localTime;
      
      console.log('Usando Shopify como fallback');
      isSynced = true;
      lastLocalTime = Date.now();
    } catch (error) {
      console.log('Error total en sincronización');
      isSynced = true;
    }
  }

  // Sincronizar con API externa de tiempo
  async function syncShopifyTime() {
  try {
    // API más confiable y con CORS habilitado
    // Hora para MEXICO
    // const timeResponse = await fetch('https://timeapi.io/api/time/current/zone?timeZone=America/Mexico_City');

    // Hora para ARGENTINA 
    // const timeResponse = await fetch('https://timeapi.io/api/time/current/zone?timeZone=America/Argentina/Buenos_Aires');

    // Hora para BRASIL
    // const timeResponse = await fetch('https://timeapi.io/api/time/current/zone?timeZone=America/Sao_Paulo');

    // Hora para PERU
    // const timeResponse = await fetch('https://timeapi.io/api/time/current/zone?timeZone=America/Lima');

    // Hora para CHILE
    const timeResponse = await fetch('https://timeapi.io/api/time/current/zone?timeZone=America/Santiago');
    
    if (timeResponse.ok) {
      const timeData = await timeResponse.json();
      // Esta API devuelve dateTime en formato ISO
      const serverTime = new Date(timeData.dateTime);
      const localTime = Date.now();
      serverTimeOffset = serverTime.getTime() - localTime;
      
      // console.log('✅ Sincronizado con TimeAPI.io');
      // console.log('Hora del servidor:', serverTime);
      // console.log('Offset (segundos):', Math.round(serverTimeOffset / 1000));
      
      isSynced = true;
      lastLocalTime = Date.now();
    } else {
      await syncWithShopify();
    }
  } catch (error) {
    // console.log('⚠️ Error con TimeAPI, usando fallback a Shopify');
    await syncWithShopify();
  }
}

  // Obtener tiempo confiable basado en servidor
  function getTrustedTime() {
    return new Date(Date.now() + serverTimeOffset);
  }

  // Inicializar el timer
  async function init() {
    updateDOMReferences();
    
    if (!timerConfig.container) {
      return;
    }
    
    await syncShopifyTime();
    
    const colorDatesRaw = timerConfig.container.getAttribute('data-color-dates');
    
    try {
      timerConfig.colorDatesData = colorDatesRaw ? JSON.parse(colorDatesRaw) : null;
    } catch (e) {
      timerConfig.colorDatesData = null;
    }

    // Detectar si el cliente tiene prioridad
    const customerTagsRaw = timerConfig.container.getAttribute('data-customer-tags');
    let customerTags = [];

    try {
      customerTags = customerTagsRaw ? JSON.parse(customerTagsRaw) : [];
    } catch (e) {
      // console.warn('Error parseando customer tags:', e);
      customerTags = [];
    }

    // SOLO actualizar si hay tags válidos
    if (customerTags.length > 0) {
      timerConfig.hasPriority = customerTags.includes('Early access');
    } else {
      // Fallback al atributo data-has-priority
      timerConfig.hasPriority = timerConfig.container.getAttribute('data-has-priority') === 'true';
    }

    // console.log('Cliente tiene Early Access:', timerConfig.hasPriority);

    setupVariantChangeListener();
    
    setTimeout(function() {
      handleVariantChange();
    }, 100);

    if (timerConfig.clockCheckInterval) {
      clearInterval(timerConfig.clockCheckInterval);
    }
    timerConfig.clockCheckInterval = setInterval(detectClockManipulation, 1000);

    if (timerConfig.syncInterval) {
      clearInterval(timerConfig.syncInterval);
    }
    timerConfig.syncInterval = setInterval(function() {
      syncShopifyTime();
    }, 300000);
  }

  // Actualizar referencias del DOM
  function updateDOMReferences() {
    timerConfig.container = document.getElementById('launch-timer');
    timerConfig.elements.days = document.getElementById('cd-days');
    timerConfig.elements.hours = document.getElementById('cd-hours');
    timerConfig.elements.minutes = document.getElementById('cd-minutes');
    timerConfig.elements.seconds = document.getElementById('cd-seconds');
  }

  // Configurar listener para cambios de variante
  function setupVariantChangeListener() {
    document.addEventListener('variant:change', function(event) {
      setTimeout(function() {
        updateDOMReferences();
        const variantData = event.detail?.variant;
        if (variantData) {
          handleVariantChange(variantData);
        } else {
          handleVariantChange();
        }
      }, 100);
    });

    const variantSelectors = document.querySelectorAll(
      '[name="id"], [name="option1"], [name="option2"], [name="option3"], ' +
      'input[type="radio"][name*="option"], select[name*="option"]'
    );
    
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        setTimeout(function() {
          updateDOMReferences();
          handleVariantChange();
        }, 150);
      });
    });

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            shouldUpdate = true;
          }
        });

        if (shouldUpdate) {
          setTimeout(function() {
            updateDOMReferences();
            const colorDatesRaw = timerConfig.container?.getAttribute('data-color-dates');
            if (colorDatesRaw) {
              try {
                timerConfig.colorDatesData = JSON.parse(colorDatesRaw);
              } catch (e) {
                // Error silencioso
              }
            }
            handleVariantChange();
          }, 200);
        }
      });

      observer.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-color-dates', 'style', 'class']
      });
    }
  }

  // Manejar cambio de variante
  function handleVariantChange(variantData) {
    if (!isSynced) {
      return;
    }

    let colorValue = null;

    if (variantData && variantData.options) {
      colorValue = variantData.options[0];
    } else {
      const colorSelectors = [
        'input[type="radio"][name*="option1"]:checked',
        'input[type="radio"][name*="Color"]:checked',
        'select[name="option1"]',
        'select[name*="Color"]',
        '[name="option1"]'
      ];

      for (let i = 0; i < colorSelectors.length; i++) {
        const selector = document.querySelector(colorSelectors[i]);
        if (selector) {
          colorValue = selector.value;
          break;
        }
      }
    }

    if (colorValue && colorValue !== timerConfig.currentColor) {
      timerConfig.currentColor = colorValue;
      updateTimer(colorValue);
    } else if (!colorValue) {
      hideTimer();
      showBuyButtons();
    }
  }

  // Actualizar timer según el color seleccionado
  function updateTimer(colorValue) {
    if (!isSynced) {
      return;
    }

    if (timerConfig.currentInterval) {
      clearInterval(timerConfig.currentInterval);
      timerConfig.currentInterval = null;
    }

    if (!timerConfig.colorDatesData || !timerConfig.colorDatesData[colorValue]) {
      hideTimer();
      showBuyButtons();
      return;
    }

    // Seleccionar fecha según prioridad
    const dateKey = timerConfig.hasPriority ? 'fechaPrioridad' : 'fechaGeneral';
    const launchDateValue = timerConfig.colorDatesData[colorValue][dateKey] || timerConfig.colorDatesData[colorValue];
    const launchDate = new Date(launchDateValue);
    const now = getTrustedTime();

    if (isNaN(launchDate.getTime()) || launchDate <= now) {
      hideTimer();
      showBuyButtons();
      return;
    }

    showTimer();
    hideBuyButtons();
    updateCountdown(launchDate);
    
    timerConfig.currentInterval = setInterval(function() {
      updateCountdown(launchDate);
    }, 1000);
  }

  // Actualizar countdown
  function updateCountdown(targetDate) {
    if (!isSynced) {
      return;
    }

    const now = getTrustedTime().getTime();
    const distance = targetDate.getTime() - now;

    if (distance < 0) {
      clearInterval(timerConfig.currentInterval);
      hideTimer();
      showBuyButtons();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    updateDOMReferences();

    if (timerConfig.elements.days) {
      timerConfig.elements.days.textContent = padZero(days);
    }
    if (timerConfig.elements.hours) {
      timerConfig.elements.hours.textContent = padZero(hours);
    }
    if (timerConfig.elements.minutes) {
      timerConfig.elements.minutes.textContent = padZero(minutes);
    }
    if (timerConfig.elements.seconds) {
      timerConfig.elements.seconds.textContent = padZero(seconds);
    }
  }

  // Agregar cero inicial
  function padZero(num) {
    return num < 10 ? '0' + num : num;
  }

  // Mostrar timer
  function showTimer() {
    updateDOMReferences();
    if (timerConfig.container) {
      timerConfig.container.style.display = 'block';
      timerConfig.container.style.visibility = 'visible';
      timerConfig.container.style.opacity = '1';
    }
  }

  // Ocultar timer
  function hideTimer() {
    updateDOMReferences();
    if (timerConfig.container) {
      timerConfig.container.style.display = 'none';
    }
    
    if (timerConfig.currentInterval) {
      clearInterval(timerConfig.currentInterval);
      timerConfig.currentInterval = null;
    }
  }

  // Ocultar botones de compra
  function hideBuyButtons() {
    const buyButtonsBlock = document.querySelector('buy-buttons');
    const submitButtons = document.querySelectorAll('button[name="add"], .product-form__submit, [type="submit"]');
    const variantPickers = document.querySelectorAll('fieldset.variant-picker__option.talla, fieldset.talla');
    
    if (buyButtonsBlock) buyButtonsBlock.style.display = 'none';
    submitButtons.forEach(function(btn) { btn.style.display = 'none'; });
    variantPickers.forEach(function(picker) { picker.style.display = 'none'; });
  }

  // Mostrar botones de compra
  function showBuyButtons() {
    const buyButtonsBlock = document.querySelector('buy-buttons');
    const submitButtons = document.querySelectorAll('button[name="add"], .product-form__submit, [type="submit"]');
    const variantPickers = document.querySelectorAll('fieldset.variant-picker__option.talla, fieldset.talla');
    
    if (buyButtonsBlock) buyButtonsBlock.style.display = '';
    submitButtons.forEach(function(btn) { btn.style.display = ''; });
    variantPickers.forEach(function(picker) { picker.style.display = ''; });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializar si la página usa Ajax
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 300);
  });

  // Limpiar al salir
  window.addEventListener('beforeunload', function() {
    if (timerConfig.currentInterval) {
      clearInterval(timerConfig.currentInterval);
    }
    if (timerConfig.syncInterval) {
      clearInterval(timerConfig.syncInterval);
    }
    if (timerConfig.clockCheckInterval) {
      clearInterval(timerConfig.clockCheckInterval);
    }
  });

})();